<div class="resources" *ngFor="let resource of resources">
  <a [href]="resource.resourceUrl" target="_blank"
    >{{ resource.resourceName }}<mat-icon class="icon-open-link">open_in_new</mat-icon></a
  >
</div>
